import { render } from "./SS23MediaCard.vue?vue&type=template&id=5dbed70f&scoped=true"
import script from "./SS23MediaCard.vue?vue&type=script&lang=js"
export * from "./SS23MediaCard.vue?vue&type=script&lang=js"

import "./SS23MediaCard.vue?vue&type=style&index=0&id=5dbed70f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbed70f"]])

export default __exports__